import { ArrowsAltOutlined, SearchOutlined } from "@ant-design/icons"
import {
  Button,
  Col,
  Divider,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from "antd"
import React, { useEffect, useState } from "react"
import { Notification } from "../../Notification"
import OrderKnife from "./OrderKnife"
import axiosInstance from "../../../axios/axiosConfig"

const { Text, Title } = Typography
const { Option } = Select

const initCode = "POLI0NAZ"
const initSate = []
export default function CalculationsPopup({
  setKniveSpaceBetweenRows,
  setKniveGapRaport,
  setLabelWidth,
  setLabelHeight,
  setSelectedKnifeCode,
  setSelectedKnifeId,
  machineAlsm,
  // setFormatWidth,
  setNumberOfColumns,
  selectedMachine,
  kniveButtonText,
  setKniveButtonText,
  setKnifePrice,
  setNewKnife,
  setKnifeShape,
  knifeShape,
  newKnifeMessage,
  setNewKnifeMessage,
  newKnifeRadiuss,
  setNewKnifeRadius,
  setNewKnifeFile,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [knifeData, setKnifeData] = useState(initSate)
  const [pending, setIsPending] = useState(false)
  const [disableButton, setDisableButton] = useState(false)

  //knife search by code
  const [searchByCode, setSearchByCode] = useState(null)
  const [knifeNumber, setKnifeNumber] = useState(0)

  const [width, setWidth] = useState(null)
  const [height, setHeight] = useState(null)
  const [range, setRange] = useState(null)

  const [selectedShape, setSelectedShape] = useState(null)

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Width",
      dataIndex: "width",
      sorter: {
        compare: (a, b) => a.width - b.width,
      },
    },
    {
      title: "Height",
      dataIndex: "height",
      sorter: {
        compare: (a, b) => a.width - b.width,
      },
    },

    {
      title: "Shape",
      dataIndex: "TypeOfForm",
      filters: [
        {
          text: "kvadrāts",
          value: "kvadrāts",
        },
        {
          text: "specforma",
          value: "specforma",
        },
        {
          text: "aplis",
          value: "aplis",
        },
        {
          text: "kvadrāts PERFO",
          value: "kvadrāts PERFO",
        },
        {
          text: "perfo",
          value: "Perfo",
        },
        {
          text: "specforma - perfo",
          value: "specforma - perfo",
        },
        {
          text: "specforma aplis",
          value: "specforma aplis",
        },
      ],
      onFilter: (value, record) => record.TypeOfForm.indexOf(value) === 0,
    },
    {
      title: "Rows",
      dataIndex: "rowss",
      sorter: {
        compare: (a, b) => a.rows - b.rows,
      },
    },
    {
      title: "Knife Width",
      dataIndex: "Knives_WIDTH_mm",
      sorter: {
        compare: (a, b) => a.Knives_WIDTH_mm - b.Knives_WIDTH_mm,
      },
    },
    {
      render: (value) => (
        <>
          <Button type="primary" block onClick={() => handleKnivechange(value)}>
            Select This
          </Button>
        </>
      ),
    },
  ]

  //handles the change, pushes knife data into array
  const handleKnivechange = async (value) => {
    const dataK = []
    dataK.push(value)
    setKniveButtonText(value.code)
    console.log(value)
    setIsModalOpen(false)
    Notification("success", "Knife Selected", "you have select a knife!")
    setKniveSpaceBetweenRows(value.spaceBetweenRows)
    setKniveGapRaport(value.gapRaport)
    setLabelWidth(value.width)
    setLabelHeight(value.height)
    setSelectedKnifeCode(value.code)
    setSelectedKnifeId(value.id)
    if (machineAlsm === 0) {
      // setFormatWidth(0);
      setNumberOfColumns(0)
    } else {
      // let formatWidth = machineAlsm * 2 + value.Knives_WIDTH_mm;
      // setFormatWidth(formatWidth);
      setNumberOfColumns(value.rowss)
    }
  }

  //filters for changing
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra)
  }

  //checks wether to disable the search button
  useEffect(() => {
    if (width && height && range && selectedShape !== null) {
      setDisableButton(false)
    } else if (searchByCode !== null && knifeNumber !== 0) {
      setDisableButton(false)
    } else {
      setDisableButton(true)
    }
  }, [width, height, range, searchByCode, selectedShape, knifeNumber])

  const fetchDataWithSearch = async () => {
    // If no code, width, or height is provided, alert the user
    if (!searchByCode && (width === null || height === null)) {
      alert("Please enter a code or both width and height.")
      return
    }

    setIsPending(true)
    try {
      const response = await axiosInstance.get(`/api/search`, {
        params: { code: searchByCode, width, height, range, shape: selectedShape },
      })

      const transformedResults = response.data.map((knife) => ({
        id: knife.id.toString(),
        code: knife.code, // Changed from lowercase to uppercase to match backend
        width: parseFloat(knife.width), // Changed from lowercase to uppercase
        height: parseFloat(knife.height), // Changed from lowercase to uppercase
        Radius: parseFloat(knife.Radius), // Added this line
        DATE_X: knife.DATE_X, // Added this line
        TypeOfForm: knife.TypeOfForm, // Added this line
        SHAPE: knife.SHAPE, // Added this line
        Client: knife.Client, // Added this line
        rowss: parseInt(knife.rowss, 10), // Added this line
        spaceBetweenRows: parseInt(knife.spaceBetweenRows, 10), // Added this line
        Form_Rows: parseInt(knife.Form_Rows, 10), // Added this line
        gapRaport: parseFloat(knife.gapRaport), // Added this line
        Z: parseInt(knife.Z, 10), // Added this line
        Z_raports: parseFloat(knife.Z_raports), // Added this line
        Rotary_Or_SemiRotary: knife.Rotary_Or_SemiRotary, // Added this line
        Knives_WIDTH_mm: parseInt(knife.Knives_WIDTH_mm, 10), // Added this line
        Material_width: parseInt(knife.Material_width, 10), // Added this line
        m_for_1k: parseInt(knife.m_for_1k, 10), // Added this line
        Used_Or_New: knife.Used_Or_New, // Added this line
        Cutter_Knives_Width_until_313mm: knife.Cutter_Knives_Width_until_313mm, // Changed from lowercase to uppercase to match backend
        Arsoma_knife_width_until_275mm_Z: knife.Arsoma_knife_width_until_275mm_Z, // Changed from lowercase to uppercase to match backend
        EM_340_knife_width_until_325_Z: knife.EM_340_knife_width_until_325_Z, // Changed from lowercase to uppercase to match backend
        VIVA_340_Minimal_paper_width_160mm: knife.VIVA_340_Minimal_paper_width_160mm, // Changed from lowercase to uppercase to match backend
        Hot_Foil: knife.Hot_Foil, // Changed from lowercase to uppercase to match backend
      }))

      console.log("original data", transformedResults) // Console log the transformed data

      console.log(selectedMachine)

      //checks if it should filter
      if (knifeNumber <= 0) {
        let filteredByMachine = null
        switch (selectedMachine) {
          case "Arsoma":
            filteredByMachine = transformedResults.filter(
              (knife) => knife.Arsoma_knife_width_until_275mm_Z === true
            )
            break
          case "Viva":
            filteredByMachine = transformedResults.filter(
              (knife) =>
                knife.VIVA_340_Minimal_paper_width_160mm === true || knife.Hot_Foil === true
            )
            break
          case "Cutter":
            filteredByMachine = transformedResults.filter(
              (knife) => knife.Cutter_Knives_Width_until_313mm === true
            )
            break
          default:
            // Handle the "default" case, possibly set filteredByMachine to the original data or show a notification
            Notification("error", "Select Machine", "You have to select machine first!")
            return transformedResults // Returning the unfiltered data might not be ideal depending on your UX design
        }
        console.log("yayaya", filteredByMachine)

        //sets final table data into knife data
        setKnifeData(filteredByMachine)
      } else {
        setKnifeData(transformedResults)
      }
    } catch (error) {
      console.error("Failed to fetch data:", error)
    } finally {
      setIsPending(false)
    }
  }

  const handleWidth = (value) => {
    setWidth(value)
    setKnifeNumber(0)
    setSearchByCode(initCode)
  }
  const handleHeight = (value) => {
    setHeight(value)
    setKnifeNumber(0)
    setSearchByCode(initCode)
  }

  const handleRange = (value) => {
    setRange(value)
    setSearchByCode(initCode)
  }

  const showModal = () => {
    setIsModalOpen(true)
    setKnifeData(initSate)
  }

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const handleSearchCode = (value) => {
    setSearchByCode("POLI" + value + "NAZ")
    setKnifeNumber(value)
    //sets the widths/heights back to 0
    setWidth(null)
    setHeight(null)
    setRange(null)
    setSelectedShape(null)
    console.log("POLI" + value + "NAZ")
  }

  return (
    <>
      <Button disabled={selectedMachine === null ? true : false} block onClick={showModal}>
        {kniveButtonText}
        {kniveButtonText === "Select" ? <SearchOutlined /> : ""}
      </Button>

      <Modal
        footer={false}
        title={"You are searching knives for: " + selectedMachine}
        width={1200}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}>
        <div>
          <Space direction="vertical">
            <Text>Cant find knife?</Text>
            <OrderKnife
              setLabelWidth={setLabelWidth}
              setLabelHeight={setLabelHeight}
              setKniveSpaceBetweenRows={setKniveSpaceBetweenRows}
              setKniveGapRaport={setKniveGapRaport}
              setKnifePrice={setKnifePrice}
              setNewKnife={setNewKnife}
              setKniveButtonText={setKniveButtonText}
              setIsModalOpen={setIsModalOpen}
              setKnifeShape={setKnifeShape}
              knifeShape={knifeShape}
              newKnifeMessage={newKnifeMessage}
              setNewKnifeMessage={setNewKnifeMessage}
              newKnifeRadiuss={newKnifeRadiuss}
              setNewKnifeRadius={setNewKnifeRadius}
              setNewKnifeFile={setNewKnifeFile}
            />
          </Space>

          <Divider />
          {/* MAIN ROW */}
          <Row gutter={16} justify="center">
            {/* FIRST COL */}
            <Col span={11}>
              <Divider>
                <Title level={2}>Search by Size</Title>
              </Divider>
              {/* INNER ROW */}
              <Row gutter={[15, 15]}>
                <Col span={24}>
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="Width"
                    value={width}
                    onChange={handleWidth}
                    prefix={
                      <ArrowsAltOutlined style={{ color: "#f5222d", fontSize: 18 }} rotate={45} />
                    }
                  />
                </Col>
                <Col span={24}>
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="Length"
                    value={height}
                    onChange={handleHeight}
                    prefix={
                      <ArrowsAltOutlined style={{ color: "#f5222d", fontSize: 18 }} rotate={135} />
                    }
                  />
                </Col>
                <Col span={24}>
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="Range"
                    value={range}
                    onChange={handleRange}
                  />
                </Col>
                <Col span={24}>
                  <Select
                    value={selectedShape}
                    placeholder="Select Form"
                    style={{ width: "100%" }}
                    onChange={(value) => setSelectedShape(value)}>
                    <Option value="any">any</Option>
                    <Option value="kvadrāts">kvadrāts</Option>
                    <Option value="specforma">specforma</Option>
                    <Option value="aplis">aplis</Option>
                    <Option value="kvadrāts Perfo">kvadrāts perfo</Option>
                    <Option value="Perfo">perfo</Option>
                    <Option value="elipse">elipse</Option>
                    <Option value="specforma - perfo">specforma - perfo</Option>
                    <Option value="specforma aplis">specforma aplis</Option>
                  </Select>
                </Col>
              </Row>
            </Col>
            {/* MIDDLE COL */}
            <Col>
              <Divider type="vertical" style={{ height: "100%" }} />
            </Col>
            {/* THIRD COL */}
            <Col span={11}>
              <Divider>
                <Title level={2}>Search by Code</Title>
              </Divider>
              <InputNumber
                style={{ width: "100%" }}
                className="input-style"
                addonBefore="POLI"
                addonAfter="NAZ"
                value={knifeNumber}
                affix="123"
                onChange={handleSearchCode}
              />
            </Col>
          </Row>
          {/* SECOND ROW */}
          <Row justify="center">
            <Col span={23}>
              <Button
                disabled={disableButton}
                style={{ marginBottom: "25px", marginTop: "25px" }}
                onClick={fetchDataWithSearch}
                type="primary"
                block>
                Search
              </Button>

              <Table
                columns={columns}
                size="small"
                rowKey={(record) => record.id}
                loading={pending}
                dataSource={knifeData}
                onChange={onChange}
                pagination={{ defaultPageSize: "5" }}
              />
            </Col>
            <Col span={23}>
              <Text style={{ color: "gray", fontStyle: "italic" }}>
                Knife range is 15. This means if you select knife 15mm wide, your maximum width will
                be 30mm.
              </Text>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  )
}
